import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'cs-sub-tab',
  templateUrl: './cs-sub-tab.component.html',
  styleUrls: ['./cs-sub-tab.component.scss'],
  standalone: true,
  imports: [],
})
export class CSSubTabComponent implements AfterViewInit, OnChanges {
  constructor(private cdr: ChangeDetectorRef) {}

  @Input() tabs: string[] = [];
  private _selectedIndex: number = 0;

  public paddingSize: string = '';

  @Input() set selectedIndex(value: number) {
    this._selectedIndex = value;
    this.updateTransform();
    this.updateBackground();
  }

  get selectedIndex(): number {
    return this._selectedIndex;
  }

  @Input() width: 'full' | 'auto' = 'full';

  @HostBinding('style.width') get hostWidth() {
    return this.width === 'full' ? '100%' : 'auto';
  }

  @Output() tabChange = new EventEmitter<number>();

  @ViewChildren('tabBtn') tabBtns!: QueryList<ElementRef<HTMLButtonElement>>;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateBackground();
    this.cdr.detectChanges();
  }

  public ngAfterViewInit() {
    this.updateBackground();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabs']) {
      // 偵測數量變化
      const prev = changes['tabs'].previousValue || [];
      const curr = changes['tabs'].currentValue || [];

      if (prev.length !== curr.length) {
        // 延遲一幀等 ViewChildren 更新完成
        setTimeout(() => {
          this.updateBackground();
        });
      }
    }
  }

  backgroundX = 0;

  backgroundWidth = 0;

  transform: string = 'translateX(0%)';

  selectTab(index: number) {
    this.selectedIndex = index;
    this.tabChange.emit(index);
  }

  updateTransform() {
    const percentage = this.selectedIndex * 100;
    const offset = this.selectedIndex * 2;
    this.transform = `translateX(calc(${percentage}% + ${offset}px))`;
  }

  updateBackground() {
    if (!this.tabBtns) {
      return;
    }

    const btn = this.tabBtns.get(this.selectedIndex);
    if (btn) {
      const el = btn.nativeElement;
      this.backgroundX = el.offsetLeft - 4;
      this.backgroundWidth = el.offsetWidth;
    }
  }
}
